import { render } from "./ContactEditCard.vue?vue&type=template&id=9b63cca8"
import script from "./ContactEditCard.vue?vue&type=script&lang=js"
export * from "./ContactEditCard.vue?vue&type=script&lang=js"

import "./ContactEditCard.vue?vue&type=style&index=0&id=9b63cca8&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__